<template>

    <v-dialog
        data-app="true"
        v-model="showDialog"
        max-width="900px"
        persistent
    >
        <toolbar-page title="Invite new user" icon="mdi-account-plus">
            <template slot="buttons">
                <v-btn @click="closeDialog" icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </toolbar-page>

        <v-form v-model="valid" ref="form" id="form">
            <v-card>

                <v-card-text>

                    <v-container fluid class="pa-0">

                        <v-row no-gutters>
                            <v-col cols="6">

                                <v-text-field
                                    label="Full name"
                                    v-model="form.data.name"
                                    :counter="60"
                                    :rules="nameRules"
                                    required
                                    :error-messages="form.getError('name')"
                                    prepend-icon="mdi-account"
                                    validate-on-blur
                                ></v-text-field>

                                <v-text-field
                                    label="Email address"
                                    v-model="form.data.email"
                                    :counter="60"
                                    :rules="emailValidationRules"
                                    required
                                    :error-messages="form.getError('email')"
                                    prepend-icon="mdi-at"
                                    validate-on-blur
                                    @input="emailChanged"
                                ></v-text-field>

                                <div class="pl-8 pt-5">
                                    Personalized message
                                </div>

                                <v-textarea
                                    v-model="form.data.message"
                                    prepend-icon="mdi-empty"
                                    hide-details
                                ></v-textarea>

                            </v-col>

                            <v-col cols="1"></v-col>

                            <v-col cols="5" class="pl-10">

                                <div class="pt-4">
                                    <h3>Roles</h3>
                                </div>

                                <div v-for="role in selectedRoles" :key="role.id">

                                    <v-checkbox hide-details
                                                :disabled="role.name==='Super Admin' && !form.data.email.includes('@sampleninja.io')"
                                                v-model="role.selected"
                                                :label="role.name"
                                    ></v-checkbox>

                                </div>
                            </v-col>

                        </v-row>
                    </v-container>

                </v-card-text>

                <v-card-actions class="pl-10">

                    <v-btn id="submitButton"
                           class="ml-2 mb-2"
                           color="primary"
                           @click="inviteUser"
                           :loading="loading"
                           :disabled="form.busy">
                        Send invitation
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-form>
    </v-dialog>

</template>

<script>

import Form from '../../../../components/forms/Form';
import {emailValidationRules} from '../../../../components/mixins/emailValidationRulesMixin';
import ToolbarPage from '../../../../components/UI/ToolbarPage';
import Json from 'vue-json-pretty';

export default {

    mixins: [emailValidationRules],

    components: {
        ToolbarPage,
        Json
    },

    props: {
        showDialog: {
            type: Boolean,
            required: true
        },
        roles: {
            type: Array,
            required: true,
        },
        errorMessages: {
            type: Object,
            required: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data() {
        return {
            form: new Form({
                name: '',
                email: '',
                roles: [],
                message: 'I have created a new Sample Ninja account for you! ' +
                    'You have 7 days to accept the account before it expires. ' +
                    'It takes just a few minutes to configure and secure your account.'
            }),
            valid: false,
            selectedRoles: [],
            nameRules: [
                (v) => !!v && v.length > 0 || 'Full name is required'
            ],
        }
    },

    mounted() {
        this.populateRoles();
    },

    watch: {

        roles() {
            this.populateRoles();
        },

        showDialog(newValue) {

            if (newValue) {
                this.form.data.name = '';
                this.form.data.email = '';
                this.form.data.roles = [];
            }
        },
        errorMessages: {
            immediate: true,
            handler(newValue) {
                this.form.setErrors(newValue);
            }
        }
    },

    methods: {

        emailChanged(email) {
            if (!email.includes('@sampleninja.io')) {
                let found = this.selectedRoles.find(role => role.name === 'Super Admin');

                if (found) {
                    found.selected = false;
                }
            }
        },

        closeDialog() {
            this.$emit('close-dialog');
        },

        populateRoles() {
            this.selectedRoles = this.roles.map(role => {

                const isSelected = role.name !== 'Super Admin';

                return {id: role.id, name: role.name, selected: isSelected}
            });
        },

        inviteUser() {

            const somethingSelected = this.selectedRoles.find(role => role.selected);

            if (!somethingSelected) {

                Bus.$emit('flash-message', {message: 'You must select at least one role!', type: 'error'});

            } else {

                this.form.data.roles =
                    this.selectedRoles
                        .filter(role => role.selected)
                        .map(role => role.name);

                this.$emit('user-invited', this.form.data);
            }
        }
    },
}
</script>
